if (!customElements.get('flaw-product-gallery')) {
  customElements.define('flaw-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.section = this.closest('.flaw-pdp');
      this.variants = JSON.parse(this.querySelector('[data-gallery-variants]').textContent);
      this.options = JSON.parse(this.querySelector('[data-gallery-options]').textContent);
      this.colorIndex = this.options.findIndex(v => /colou?r/i.test(v));
      this.figures = [...this.querySelectorAll('.flaw-gallery__media')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.images = this.querySelector('.flaw-gallery__images');
      this.norm = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      this.colors = this.colorIndex < 0 ? [] : [...new Set(this.variants.map(v => v.options[this.colorIndex]))].sort((a,b) => b.length-a.length);
      this.groups = new Map(this.figures.map(f => {
        const alt = ' '+this.norm(f.dataset.alt)+' ';
        const match = this.colors.find(c => alt.includes(' '+this.norm(c)+' '));
        const anchor = this.variants.find(v => String(v.featured_media?.id) === f.dataset.mediaId);
        return [f.dataset.mediaId, match || (anchor && this.colorIndex >= 0 ? anchor.options[this.colorIndex] : '')];
      }));
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.thumbs.forEach(a => a.addEventListener('click', e => { e.preventDefault(); this.go(a.dataset.thumb); }, {signal}));
      this.querySelectorAll('.flaw-gallery__zoom').forEach(a => a.addEventListener('click', e => {
        e.preventDefault();
        const dialog = document.createElement('dialog');
        dialog.className = 'flaw-gallery-dialog';
        const img = document.createElement('img'); img.src = a.href; img.alt = a.querySelector('img').alt;
        const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Cerrar');
        close.addEventListener('click', () => dialog.close());
        dialog.append(img, close); document.body.append(dialog);
        dialog.addEventListener('close', () => dialog.remove(), {once:true}); dialog.showModal();
      }, {signal}));
      this.section.addEventListener('variantChange', e => { if(e.detail.variant) this.select(e.detail.variant, true); }, {signal});
      this.decorateColors();
      this.select(this.variants.find(v => String(v.id) === this.dataset.selectedVariant) || this.variants[0], false);
      this.observer = new IntersectionObserver(entries => {
        const visible = entries.filter(e => e.isIntersecting && !e.target.hidden).sort((a,b) => b.intersectionRatio-a.intersectionRatio)[0];
        if (visible) this.mark(visible.target.dataset.mediaId);
      }, {threshold:[.25,.5,.75]});
      this.figures.forEach(f => this.observer.observe(f));
    }
    decorateColors() {
      if(this.colorIndex < 0) return;
      const field = this.section.querySelector('.variant-input-wrap[data-index="option'+(this.colorIndex+1)+'"]');
      if(!field) return;
      const wrapper = field.closest('.variant-wrapper');
      wrapper.style.order = '-1';
      wrapper.parentElement.style.display = 'flex'; wrapper.parentElement.style.flexDirection = 'column';
      const title = wrapper.querySelector('.variant__label');
      this.colorText = document.createElement('span'); this.colorText.className='flaw-current-color'; title?.append(this.colorText);
      field.querySelectorAll('.variant-input').forEach(input => {
        const variant = this.variants.find(v => v.options[this.colorIndex] === input.dataset.value && v.featured_image);
        const label = input.querySelector('label');
        if(!variant || !label) return;
        const img = document.createElement('img'); img.src=variant.featured_image.src; img.alt=''; img.className='flaw-option-image'; img.loading='lazy';
        const text = document.createElement('span'); text.textContent=input.dataset.value;
        label.replaceChildren(img,text); label.classList.add('flaw-color-label'); label.title=input.dataset.value;
      });
    }
    select(variant, changed) {
      if(!variant) return;
      const color = this.colorIndex < 0 ? '' : variant.options[this.colorIndex];
      if(changed && color === this.color) return;
      this.color = color;
      if(this.colorText) this.colorText.textContent = color;
      const hasMatch = this.figures.some(f => this.groups.get(f.dataset.mediaId) === color);
      this.figures.forEach(f => {
        const group = this.groups.get(f.dataset.mediaId);
        f.hidden = Boolean(color && hasMatch && group && group !== color);
        this.thumbs.find(a => a.dataset.thumb === f.dataset.mediaId).hidden=f.hidden;
      });
      const first = this.figures.find(f => !f.hidden);
      const target = this.figures.find(f => !f.hidden && String(variant.featured_media?.id) === f.dataset.mediaId) || first;
      if (first) this.mark(target.dataset.mediaId);
      this.images.scrollLeft = 0;
      if(changed && target) this.go(target.dataset.mediaId);
    }
    mark(id) { this.thumbs.forEach(a => a.setAttribute('aria-current', String(a.dataset.thumb===id))); }
    go(id) {
      const target = this.figures.find(f => f.dataset.mediaId===id);
      if(!target) return;
      const behavior=matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';
      if(matchMedia('(max-width:989px)').matches) this.images.scrollTo({left:target.offsetLeft-this.images.offsetLeft,behavior});
      else window.scrollTo({top:target.getBoundingClientRect().top+window.scrollY-96,behavior});
      this.mark(id);
    }
    disconnectedCallback(){ this.abort?.abort(); this.observer?.disconnect(); this.ready=false; }
  });
}
